"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consumerListFailure = exports.consumerListSuccess = exports.consumerListReset = exports.consumerListLoading = exports.consumerListRequest = void 0;

var _constant = require("./constant");

var consumerListRequest = function consumerListRequest() {
  return {
    type: _constant.ConsumerListTypes.CONSUMER_LIST_REQUEST
  };
};

exports.consumerListRequest = consumerListRequest;

var consumerListLoading = function consumerListLoading() {
  return {
    type: _constant.ConsumerListTypes.CONSUMER_LIST_LOADING
  };
};

exports.consumerListLoading = consumerListLoading;

var consumerListReset = function consumerListReset() {
  return {
    type: _constant.ConsumerListTypes.CONSUMER_LIST_RESET
  };
}; // payload is object with result as key for consumer list array


exports.consumerListReset = consumerListReset;

var consumerListSuccess = function consumerListSuccess(payload) {
  return {
    type: _constant.ConsumerListTypes.CONSUMER_LIST_SUCCESS,
    payload: payload
  };
}; // payload is string of error message


exports.consumerListSuccess = consumerListSuccess;

var consumerListFailure = function consumerListFailure(payload) {
  return {
    type: _constant.ConsumerListTypes.CONSUMER_LIST_FAILURE,
    payload: payload
  };
};

exports.consumerListFailure = consumerListFailure;